import {observer} from "mobx-react";
import {useStores} from "../../Hooks";
import TextField from "@mui/material/TextField";
import React from "react";

const OnBoardingInput = observer((props) => {
    const {generalStore} = useStores();
    const {
        onKeyDown,
        onEnterPressed,
        className,
        placeholder,
        dataKey,
        "data-testid": dataTestId,
        ...otherProps
    } = props;
    return (
        <TextField
            id={dataKey}
            className={`${className || ''} step-form-input`}
            placeholder={placeholder}
            variant='outlined'
            value={generalStore.signInData[dataKey]}
            onChange={e => generalStore.signInData[dataKey] = e.target.value}
            onKeyDown={(e) => {
                if (onEnterPressed && e.key === 'Enter') {
                    onEnterPressed();
                } else if (onKeyDown) {
                    onKeyDown(e)
                }
            }}
            inputProps={{
                "data-testid": dataTestId
            }}
            {...otherProps}
        />
    )
});

export default OnBoardingInput;
